<template>
  <div class="schedule-table" tabindex="0">
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th class="date-header header fixed name-header" :style="{ backgroundColor: headerBcakgroungColor }">姓名</th>
            <th v-for="(day, index) in days" :key="index" class="date-header header"
              :style="{ backgroundColor: headerBcakgroungColor }">
              {{ day.month }}月{{ day.day }}日<br />
              {{ day.dayOfWeek }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(person, rowIndex) in uniquePersons" :key="person.employNo">
            <td class="fixed name-cell">
              <div
                style="border-top: 1px solid #ccc;height: 100%;display: flex;align-items: center;justify-content: center;">
                {{ person.employName }}
              </div>
            </td>
            <td v-for="(day, colIndex) in days" :key="colIndex" :class="getCellClass(rowIndex, colIndex)"
              @mousedown="startSelection(rowIndex, colIndex)" @mouseover="continueSelection(rowIndex, colIndex)"
              @mouseup="endSelection" @dblclick="activateEditor(rowIndex, colIndex)">

              <template v-if="editingCell && editingCell[0] === rowIndex && editingCell[1] === colIndex">
                <input @blur="handleBlur" placeholder="请输入" ref="myInput" type="text"
                  style="text-align: center; width: 90%;" v-model="localValue[person.employNo][colIndex]">
              </template>
              <template v-else>
                <span :style="getCellStyle(localValue[person.employNo][colIndex])">
                  {{ localValue[person.employNo][colIndex] }}
                </span>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'test-model',
  props: {
    year: {
      type: String,
      default: '',
    },
    month: {
      type: String,
      default: '',
    },
    headerBcakgroungColor: {
      type: String,
      default: '',
    },
    employName: {
      type: Array,
      default: () => [
        // { employNo: "1", employName: "张三" },
        // { employNo: "2", employName: "李四" },
        // { employNo: "3", employName: "王五" },
        // { employNo: "4", employName: "任六" },
        // { employNo: "5", employName: "任六" },

      ],
    },
    value: {
      type: Array,
      default: () => [
        // { id: '120', employNo: "1", employName: "张三", value: "9", wxDate: "2025-05-01" },
        // { id: '121', employNo: "2", employName: "李四", value: "5", wxDate: "2025-05-02" },
        // { id: '122', employNo: "2", employName: "李四", value: "0", wxDate: "2025-04-03" },
        // { id: '123', employNo: "3", employName: "王五", value: "2", wxDate: "2025-04-04" },
        // { id: '124', employNo: "4", employName: "任六", value: "1", wxDate: "2025-04-24" },
      ],
    },
  },
  data() {
    return {
      localValue: {},
      historyStack: [],
      redoStack: [],
      isSelecting: false,
      selectionStart: null,
      selectionEnd: null,
      copiedRange: null,
      editingCell: null,
      selectionChanged: false,
    };
  },
  computed: {
    days() {
      const year = parseInt(this.year, 10);
      const month = parseInt(this.month, 10) - 1;
      const firstDay = new Date(Date.UTC(year, month, 1));
      const lastDay = new Date(Date.UTC(year, month + 1, 0));
      const days = [];
      for (let day = firstDay; day <= lastDay; day.setDate(day.getDate() + 1)) {
        const dayObj = {
          year: day.getUTCFullYear(),
          month: day.getUTCMonth() + 1,
          day: day.getUTCDate(),
          date: new Date(Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate())),
          dayOfWeek: this.getDayOfWeek(day)
        };
        days.push(dayObj);
      }
      return days;
    },
    uniquePersons() {
      const uniqueMap = new Map();
      this.employName.forEach(person => {
        if (!uniqueMap.has(person.employNo)) {
          uniqueMap.set(person.employNo, {
            employNo: person.employNo,
            employName: person.employName
          });
        }
      });
      return Array.from(uniqueMap.values());
    }
  },
  watch: {
    year: {
      handler() {
        this.initLocalValue();
      },
      immediate: true,
    },
    month: {
      handler() {
        this.initLocalValue();
      },
      immediate: true,
    },
    value: {
      handler() {
        this.initLocalValue();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.initYearAndMonth();
    this.initLocalValue();
  },
  methods: {
    initYearAndMonth() {
      const now = new Date();
      this.year = this.year || now.getFullYear().toString();
      this.month = this.month || (now.getMonth() + 1).toString().padStart(2, '0');
    },
    handleBlur(event) {
      this.editingCell = null;
      this.emitValue();
    },
    getCellStyle(value) {
      return {
        color: '',
        backgroundColor: value ? '' : '',
        fontWeight: '',
        width: '100%',
        height: '100%',
        borderRadius: '0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },
    initLocalValue() {
      const base = {};
      // 基于 uniquePersons 初始化
      this.uniquePersons.forEach(person => {
        base[person.employNo] = Array(this.days.length).fill(null); // 初始化为null，方便后续判断
      });

      // 填充已有数据
      this.value.forEach(item => {
        const colIndex = this.days.findIndex(day =>
          this.formatDate(day.date) === this.formatDate(new Date(item.wxDate))
        );
        if (colIndex !== -1 && base[item.employNo] !== undefined) {
          base[item.employNo][colIndex] = item.value; // 保留已有值
        }
      });

      // 将null替换为'0'
      this.uniquePersons.forEach(person => {
        base[person.employNo] = base[person.employNo].map(value => value === null ? '0' : value);
      });

      this.localValue = base;
    },
    emitValue() {
      // 创建一个映射，方便快速查找已有的记录
      const valueMap = new Map(this.value.map(item => [`${item.employNo}-${this.formatDate(new Date(item.wxDate))}`, item]));

      // 遍历所有人员和日期
      this.uniquePersons.forEach(person => {
        const row = this.localValue[person.employNo];
        row.forEach((cell, colIndex) => {
          const wxDate = this.formatDate(this.days[colIndex].date);
          const key = `${person.employNo}-${wxDate}`;

          if (cell !== '0') {
            if (valueMap.has(key)) {
              // 更新已有记录
              valueMap.get(key).value = cell;
            } else {
              // 添加新记录
              const newItem = {
                id: undefined,
                employNo: person.employNo,
                employName: person.employName,
                value: cell,
                wxDate: wxDate
              };
              this.value.push(newItem);
            }
          }
        });
      });

      // 触发事件
      this.$emit('input', this.value);
      this.$emit('value', this.value);
      this.$forceUpdate();
      console.log(this.value);
    },
    startSelection(row, col) {
      this.selectionStart = [row, col];
      this.selectionEnd = [row, col];
      this.isSelecting = true;
      this.selectionChanged = false;
    },
    continueSelection(row, col) {
      if (this.isSelecting) {
        this.selectionEnd = [row, col];
        this.selectionChanged = true;
      }
    },
    endSelection() {
      this.isSelecting = false;
    },
    activateEditor(row, col) {
      this.editingCell = [row, col];
      this.$nextTick(() => {
        if (this.$refs.myInput) {
          this.$refs.myInput[0].focus();
        } else {
          console.error("Input element not found");
        }
      });
    },
    getCellClass(row, col) {
      const classes = [];
      const isSelected = this.selectionStart && this.selectionEnd && this.isInRange(row, col, this.selectionStart, this.selectionEnd);
      const isCopied = this.copiedRange && this.isInRange(row, col, this.copiedRange.start, this.copiedRange.end);
      if (isSelected) classes.push('selected', ...this.getSelectedBorderClass(row, col));
      if (isCopied) classes.push('copied-cell', ...this.getCopiedBorderClass(row, col));
      return classes;
    },
    isInRange(row, col, start, end) {
      const [sr, sc] = start;
      const [er, ec] = end;
      return row >= Math.min(sr, er) && row <= Math.max(sr, er) && col >= Math.min(sc, ec) && col <= Math.max(sc, ec);
    },
    getSelectedBorderClass(row, col) {
      const [sr, sc] = this.selectionStart;
      const [er, ec] = this.selectionEnd;
      const minRow = Math.min(sr, er);
      const maxRow = Math.max(sr, er);
      const minCol = Math.min(sc, ec);
      const maxCol = Math.max(sc, ec);
      const borders = [];
      if (row === minRow) borders.push('selected-border-top');
      if (row === maxRow) borders.push('selected-border-bottom');
      if (col === minCol) borders.push('selected-border-left');
      if (col === maxCol) borders.push('selected-border-right');
      return borders;
    },
    getDayOfWeek(date) {
      const days = ['日', '一', '二', '三', '四', '五', '六'];
      return `星期${days[date.getUTCDay()]}`;
    },
    formatDate(date) {
      if (!(date instanceof Date)) {
        return '';
      }
      return date.toISOString().split('T')[0];
    },
  },
};
</script>

<style scoped>
/* 保持原有的样式不变 */
.schedule-table {
  box-sizing: border-box;
  overflow: auto;
  border: 1px solid #ccc;
  outline: none;
}

th {
  font-size: 12px;
}

td span,
.select-editor {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  line-height: 1.4;
  border-radius: 4px;
  font-family: inherit;
  vertical-align: middle;
  padding: 0;
  font-size: 12px;
  height: 24px;
}

td span {
  font-size: 12px;
}

.select-editor {
  border: 1px solid #ccc;
  background-color: #fff;
  outline: none;
  box-sizing: border-box;
}

.table-wrapper {
  overflow: auto;
  max-width: 100%;
}

table {
  border-collapse: collapse;
  width: max-content;
  min-width: 100%;
}

th,
td {
  border: 1px solid #ccc;
  width: 80px;
  height: 32px;
  text-align: center;
  user-select: none;
  box-sizing: border-box;
  font-size: 12px;
  padding: 0px;
}

.date-header {
  background-color: rgb(85, 184, 184);
  color: white;
}

.fixed.index-header,
.fixed.name-header {
  background-color: rgb(85, 184, 184);
  color: white;
  position: sticky;
  left: 0;
  z-index: 2;
}

.fixed.index-cell,
.fixed.name-cell {
  background-color: #fff;
  color: black;
  position: sticky;
  left: 0;
  top: 0px;
  z-index: 1;
}

.selected {
  background-color: #E0EEFB;
}

@keyframes ants {
  to {
    background-position: 100%;
  }
}

.copied-border-top {
  border-top: 2px dashed #0078ee;
}

.copied-border-bottom {
  border-bottom: 2px dashed #0078ee;
}

.copied-border-left {
  border-left: 2px dashed #0078ee;
}

.copied-border-right {
  border-right: 2px dashed #0078ee;
}

.selected-border-top {
  border-top: 2px solid #0078ee;
}

.selected-border-bottom {
  border-bottom: 2px solid #0078ee;
}

.selected-border-left {
  border-left: 2px solid #0078ee;
}

.selected-border-right {
  border-right: 2px solid #0078ee;
}

.select-editor {
  width: 100%;
  padding: 0;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  background-color: #fff;
  font-family: inherit;
}
</style>